const ADD_ERROR = "ADD_ERROR";
const DELETE_ERROR = "DELETE_ERROR";
export function AddError(error) {
    return {
        type: ADD_ERROR,
        payload: error
    };
}
export function DeleteError(index) {
    return {
        type: DELETE_ERROR,
        index: index
    };
}
const initialState = {
    errors: []
};
export function errorsReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_ERROR:
            return {
                errors: [...state.errors, action.payload]
            };
        case DELETE_ERROR:
            return {
                errors: state.errors.filter(error => error.index === action.index)
            };
        default:
            return state;
    }
}
